import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions.js";
import Column from "../layout/Column.js";
import Row from "../layout/Row.js";
import Divider from "../layout/Divider.js";
import Icon1 from "../icons/Icon.js";
import Space from "../layout/Space.js";
import InfoCell from "../listviews/InfoCell.js";
import {
  getDateFromFlutter,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getLocalStringFromFlutter,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import "../animations/animations.css";
import { useTheme } from "@mui/material";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";

import InvoicesAM from "../actionmenus/InvoiceAM.js";
import getTemporaryUrl from "../api/getTemporaryUrl.js";
import { useAppContext } from "../config/AppContext.js";
import PDF from "../pdf/PDF.js";
import Modal1 from "../modals/Modal1.js";
import { useSnackbar } from "notistack";

import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import sendDVemail from "../api/sign/sendDVemail.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import { formatToEuro } from "./NewInvoiceDraft.js";
import EmailModal from "../modals/EmailModal.js";
import { format } from "date-fns";
import SmallSpinner from "../loading/SmallSpinner.js";
import PaymentAM from "../actionmenus/PaymentAM.js";
import { EditableInfoCell } from "./folder_pages/folder_sidebar/FolderInformationSection.js";

const Payment = ({ userData, orgData, navigateWorkspace, workspaceData }) => {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();
  const [createFolderOpen, setCreateFolderOpen] = React.useState(false);

  const [masterData, setMasterData] = useState(null);
  const [emailOpen, setEmailOpen] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [folderData, setFolderData] = useState(null);
  const [emails, setEmails] = useState([]);
  // Initialize access states (all false by default) in the parent

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (userData) {
      try {
        let master;
        if (!workspaceData) {
          master = orgData;
          setMasterData(master);
        } else if (workspaceData) {
          master = await getOrgById(workspaceData.master_id);
          setMasterData(master);
        }

        const payment = await getDocDataById("payment", id);
        if (!payment) {
          console.error("No payment found with id", id);
          navigateWorkspace("/payments");
          return;
        }
        if (payment.master_id !== master.id) {
          navigateWorkspace("/payments");
          console.error("No access to this payment");
          return;
        }
        const folder = await getDocDataByRef(payment.folder_ref);
        setFolderData(folder);

        setPaymentData(payment);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };
  const [loadingFile, setLoadingFile] = useState(null);
  const handleViewFile = async (file) => {
    setLoadingFile(file.name);
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(token, "rapport-payment", "", folderData.id, prefix);
    const new_payment = await getDocDataById("payment", id);
    setPaymentData(new_payment);
    let rapport_files = new_payment.rapport_files;
    let matching_file = rapport_files.find((f) => f.name === file.name);
    matching_file.url
      ? window.open(matching_file.url, "_blank")
      : handleClickVariant("Le fichier n'est pas disponible", "error");
    setLoadingFile(null);
  };

  const [loadingFacture, setLoadingFacture] = useState(false);
  const handleOpenPdf = async () => {
    setLoadingFacture(true);
    const token = await getOrRefreshFirebaseToken();
    await getTemporaryUrl(
      token,
      "facture",
      "",
      paymentData.folder_ref.id,
      prefix
    );
    const new_payment = await getDocDataById("payment", id);
    setPaymentData(new_payment);
    if (!new_payment.facture_file?.url) {
      handleClickVariant("Le fichier n'est pas disponible", "error");
      return;
    }
    new_payment.facture_file.url
      ? setPDFOpen([new_payment.facture_file])
      : handleClickVariant("Le fichier n'est pas disponible", "error");

    setLoadingFacture(false);
  };
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const theme = useTheme();

  const [pdf_open, setPDFOpen] = useState(null);

  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  // Handle navigation to clients page
  const gotoPayments = () => {
    navigateWorkspace("/payments");
  };

  if (loading || !currentUser || !orgData || !paymentData) {
    return (
      <div className="w-full h-full flex flex-col justify-center items-center">
        <SmallSpinner></SmallSpinner>
      </div>
    ); // Show loading state while checking auth or if currentUser is null
  }

  return (
    <div className="w-full h-full overflow-auto flex flex-col gap-2">
      <div className="flex flex-row gap-4 w-full h-fit">
        <div className="flex flex-col gap-1 w-full h-fit">
          <Modal1 isOpen={pdf_open} onClose={() => setPDFOpen(null)}>
            <div className="flex flex-col w-c900 h-fit bg-neutral-100 rounded-md">
              {" "}
              <PDF files={pdf_open} onClose={() => setPDFOpen(null)}></PDF>
            </div>
          </Modal1>
          <Modal1 isOpen={emailOpen} onClose={() => setEmailOpen(false)}>
            <EmailModal
              paymentData={paymentData}
              isOpen={emailOpen}
              onClose={(wanted = false) => {
                if (wanted) {
                  setEmailOpen(false);
                  handleFetchData();
                }
              }}
              orgData={orgData}
              masterData={masterData}
              navigateWorkspace={navigateWorkspace}
              workspaceData={workspaceData}
            ></EmailModal>
          </Modal1>
          {/* Left Column: Takes all available space */}
          <div className="flex flex-col gap-1 h-full flex-grow pl-4 text-h3">
            <Space y={20} />
            <div className="flex flex-row gap-1 w-full  ">
              <div
                className="flex flex-row gap-1  w-full cursor-pointer"
                onClick={gotoPayments}
              >
                <div className="text-h2 font-semibold text-primary_l bg-transparent">
                  Paiements
                </div>
                <Icon1 icon_name="right" height="15px"></Icon1>
              </div>

              <div className="flex w-fit min-w-fit">
                {paymentData?.state !== "draft" && (
                  <SecondaryButton className="w-fit" onClick={handleOpenPdf}>
                    Voir la facture{" "}
                    {loadingFacture && <SmallSpinner></SmallSpinner>}
                  </SecondaryButton>
                )}

                <Space x={10} />
                {(paymentData?.state !== "draft" || !workspaceData) && (
                  <PaymentAM
                    orgData={orgData}
                    paymentData={paymentData}
                    folderData={folderData}
                    handleRefresh={handleFetchData}
                    navigateWorkspace={navigateWorkspace}
                    workspaceData={workspaceData}
                    masterData={masterData}
                    createFolderOpen={createFolderOpen}
                    setCreateFolderOpen={setCreateFolderOpen}
                    setEmailOpen={setEmailOpen}
                  />
                )}
              </div>
            </div>
            <Space y={5} />
            <div className="text-hx font-semibold">{paymentData?.nom}</div>{" "}
            <Space y={5} />
            {paymentData.state === "draft" && (
              <div className="flex flex-col mb-4 gap-2">
                <div className="flex flex-row px-2 py-0.5 items-center rounded-xl bg-neutral-500 text-white w-fit">
                  Brouillon
                </div>

                <div className="flex flex-row px-2 py-0.5 items-center rounded-xl bg-green-100 text-black w-fit">
                  En attente de création par {masterData?.name}
                </div>

                {!workspaceData && (
                  <PrimaryButton
                    onClick={handleGenerateDevis}
                    className={"w-fit"}
                  >
                    Générer le devis à partir du brouillon
                  </PrimaryButton>
                )}
              </div>
            )}
            {paymentData.state === "locked" && (
              <div className="flex flex-row gap-2">
                <div className="flex flex-row px-2 py-0.5 items-center rounded-xl bg-neutral-400 text-white w-fit">
                  Pas encore envoyé
                </div>
                <PrimaryButton
                  onClick={() => setEmailOpen(true)}
                  className={"w-fit"}
                >
                  Envoyer le devis à signer
                </PrimaryButton>
              </div>
            )}
            {paymentData.state === "paid" && (
              <div className="flex flex-row gap-2">
                <div
                  className={`
                  ${paymentData?.bridge?.status === "ACSC" ? "bg-green-300" : "bg-lime-400"}
                  flex flex-row px-2 py-0.5 items-center rounded-xl  text-white w-fit`}
                >
                  Payé{" "}
                  {paymentData?.bridge?.status === "ACSC"
                    ? "via Bridge"
                    : " en direct"}
                </div>

                <PrimaryButton
                  onClick={() => setCreateFolderOpen(true)}
                  className={"w-fit"}
                >
                  Aller au dossier
                </PrimaryButton>
              </div>
            )}
            {paymentData.state === "wait" && (
              <div className="flex flex-row px-2 py-0.5 items-center rounded-xl bg-orange-300 text-white w-fit">
                En attente
              </div>
            )}
            {paymentData.state === "error" && (
              <div className="flex flex-row px-2 py-0.5 items-center rounded-xl bg-red-400 text-white w-fit">
                Erreur
              </div>
            )}
            {paymentData.state === "cancelled" && (
              <div className="flex flex-row px-2 py-0.5 items-center rounded-xl bg-red-400 text-white w-fit">
                Annulé
              </div>
            )}
            <Space y={5} />
            <div className="flex flex-row gap-2 w-full">
              <div className=" font-semibold text-pr bg-transparent">
                Client
              </div>

              <div
                className={`inline-flex h-5  items-center rounded-full px-2 py-1 flex-row text-blue-400  bg-blue-50   font-light `}
              >
                {folderData?.marque}
              </div>
            </div>
            <div className="w-full flex flex-row gap-2 text-h3">
              <div className="font-semibold text-pr bg-transparent">
                Date de création
              </div>
              <div className=" font-light text-pr bg-transparent">
                {paymentData?.creation_date &&
                  getLocalStringFromFlutter(paymentData?.creation_date)}
              </div>
            </div>
            <Space y={20} />
            <div className="text-h1 font-semibold">Historique</div>
            <Space y={10} />
            {paymentData?.history_events?.map((event, index) => (
              <div key={index} className="flex flex-col">
                {index !== 0 && (
                  <div
                    className="h-6 border-l-1 border-shadow_25 w-0"
                    style={{
                      marginLeft: "5px",
                    }}
                  ></div>
                )}
                <div className="flex flex-row gap-2 items-center">
                  <div className="rounded-full border-1 border-shadow_50 h-3 w-3 "></div>{" "}
                  <div className="flex text-h3 text-shadow_50 ">
                    {new Date(event.date.seconds * 1000).toLocaleString()}
                  </div>
                  <div className="flex text-h3 text-shadow_50">
                    {event.name}
                  </div>
                </div>
              </div>
            ))}
            <Space y={20} />
            {paymentData?.master_id === orgData?.id && (
              <>
                <div className="text-h1 font-semibold"> Rapports déposés</div>
                <Space y={5} />
                {paymentData?.rapport_files &&
                  paymentData?.rapport_files?.length > 0 && (
                    <div className="flex flex-col gap-2 w-full mb-4">
                      {paymentData?.rapport_files?.map((file, index) => (
                        <div key={index} className="flex w-full">
                          <div className="flex flex-row items-center gap-2">
                            <SecondaryButton
                              className={"w-fit"}
                              onClick={() => handleViewFile(file)}
                            >
                              {limitStringSize(file.name)}
                              {loadingFile === file.name ? (
                                <SmallSpinner></SmallSpinner>
                              ) : (
                                <Icon1
                                  icon_name="open"
                                  size={15}
                                  fill="grey"
                                ></Icon1>
                              )}
                            </SecondaryButton>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
              </>
            )}
            {/* <div className="text-h1 font-semibold"> Emails envoyés</div>
            <Space y={5} />
            {emails.length === 0 && (
              <div className="flex flex-col  w-fit rounded-xl items-center h-fit my-1 bg-neutral-50 p-2 border-l-3 border-neutral-400 ">
                <div className="text-h3 text-neutral-400 font-medium   gap-2 flex flex-row items-center">
                  <Icon1 icon_name="email" fill="grey" size={20} />
                  Aucun email envoyé pour ce dossier
                </div>
              </div>
            )}
            {emails.map((email, index) => (
              <div
                key={index}
                className="flex flex-col gap-1 border-l-4 border-blue-400 p-2 m-2 rounded-xl bg-blue-50"
              >
                <div className="flex flex-row justify-between ">
                  <div className="text-h3 ">{email.object}</div>
                  <div className="text-h3 text-shadow_10">{email.id}</div>

                  <div
                    className={`text-h3 text-white ${
                      email.resend_email_status === "email.complained"
                        ? "bg-red-400"
                        : email.resend_email_status === "email.bounced"
                          ? "bg-red-400"
                          : email.resend_email_status === "email.delivered"
                            ? "bg-green-400"
                            : email.resend_email_status ===
                                "email.delivered_delayed"
                              ? "bg-orange-400"
                              : ""
                    }`}
                  >
                    {email.resend_email_status === "email.complained"
                      ? "marqué comme spam"
                      : email.resend_email_status === "email.bounced"
                        ? "rejeté"
                        : email.resend_email_status === "email.delivered"
                          ? "reçu"
                          : email.resend_email_status ===
                              "email.delivered_delayed"
                            ? "temporairement bloqué"
                            : ""}
                  </div>
                </div>
                <div className="text-h3 flex flex-row   text-shadow_50 gap-2 items-center">
                  <Icon1 icon_name="date" fill="grey" size={18}></Icon1>
                  {format(email.date.toDate(), "dd/MM/yyyy HH:mm")}
                </div>
                {email.emails?.map((email, index) => (
                  <div
                    key={index}
                    className="text-h3 text-shadow_50 flex flex-row gap-2 items-center"
                  >
                    <Icon1 icon_name="email" fill="grey" size={18}></Icon1>
                    {email}
                  </div>
                ))}
                <div className="text-h3 text-shadow_50 whitespace-pre-wrap  ">
                  {email.content?.includes("<!DOCTYPE html")
                    ? "Rappel envoyé"
                    : email.content}{" "}
                </div>
              </div>
            ))}
            <Space y={30} />
          */}
          </div>{" "}
        </div>
        {/* Right Column: Fixed width */}
        <div className="flex flex-col gap-1 h-full max-w-c400 pl-2">
          <Space y={20} />
          <div className="text-h1 font-semibold">Informations</div>
          <Space y={5} />
          <div className="flex flex-col gap-1 w-full pr-2">
            <InfoCell title="ID" data={paymentData?.id} />
            <InfoCell
              title="Montant"
              data={formatToEuro(paymentData?.amount)}
            />
            <Space y={20} />
            <div className="text-h1 font-semibold"> Coordonnées</div>
            <Space y={5} />
            <InfoCell title="Nom" data={paymentData?.nom} />
            <InfoCell
              title="Prénom"
              data={paymentData?.reglement_infos?.first_name}
            />
            <InfoCell
              title="Email"
              data={paymentData?.reglement_infos?.email}
            />
            <InfoCell
              title="Téléphone"
              data={paymentData?.reglement_infos?.phone}
            />
            <InfoCell
              title="Adresse"
              data={paymentData?.reglement_infos?.address}
            />
            <InfoCell
              title="Postal"
              data={paymentData?.reglement_infos?.postal}
            />
            <InfoCell title="Ville" data={paymentData?.reglement_infos?.city} />
            <Space y={20} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payment;
export function limitStringSize(string, limit = 35) {
  return string.length > limit ? string.substring(0, limit) + "..." : string;
}
